import { observable, action, computed, toJS } from "mobx";
import { readToken } from "helpers/token";
import { AppStore } from ".";

class UserStore {
	protected appStore: AppStore;

	@observable public loading = true;
	@observable public token = "";
	@observable public aanLogin = false;
	@observable public isLoggedIn = false;
	@observable public user: Partial<Account.Profile> = {};
	@observable public profileImage ?= "";
	@observable public baazarConfigs: any = {};

	@observable public text = "";
	@observable public balance = 0;
	@observable public goldCredit = 0;
	@observable public goldBuyPrice = 0;
	@observable public goldSellPrice = 0;
	@observable public assetsPrices: Stock.PriceChart[] = [];

	constructor(appStore: AppStore) {
		this.appStore = appStore;

		this.loggedInStatus(Boolean(readToken()));
	}

	@action
	prepareUser(user: Account.Profile) {
		this.user = user;
	}

	@action
	resetUser() {
		this.isLoggedIn = false;
		this.token = "";
		this.user = {};
	}

	@action
	setAanLogin() {
		this.aanLogin = true;
	}

	@action
	loggedInStatus(isLoggedIn: boolean) {
		this.isLoggedIn = isLoggedIn;
	}

	@action
	setToken(token: string) {
		this.token = `Bearer ${token}`;
	}

	@action
	updateShebaNumber(bankShabaNumber: string) {
		// @ts-ignore
		this.user.profile.bankShabaNumber = bankShabaNumber;
	}

	@action
	updateProfile(data: Account.ProfileDetail) {
		this.user.profile = data;
	}

	@action
	setAccountCredits(data: Account.Dashboard) {
		this.text = data.text;
		this.balance = data.currentRial;
		this.goldCredit = data.currentGold;
		this.goldBuyPrice = data.goldBuyPrice;
		this.goldSellPrice = data.goldSellPrice;
	}

	@action
	setUserBalance(balance: number) {
		this.balance = balance;
	}

	@action
	setProfileImage(img: string) {
		this.profileImage = img;
	}

	@action
	setLoading(loading: boolean) {
		this.loading = loading;
	}

	@action
	setAssetsPrices(prices: Stock.PriceChart[]) {
		this.assetsPrices = prices;
	}

	@action
	setBaazarConfigs(configs: BaseTypesModel.BaazarConfig) {
		this.baazarConfigs = configs;
	}

	@computed
	get totalCredit(): number {
		return Math.ceil(this.goldCredit * this.goldSellPrice + this.balance);
	}

	@computed
	get getUser(): Partial<Account.Profile> {
		return toJS(this.user);
	}

	@computed
	get getAssetsPrices(): Array<Stock.AssetPrices> {
		// @ts-ignore
		return toJS(this.assetsPrices) || [];
	}
}

export default UserStore;
